import React from "react";

// Markdown mínimo para respostas de modelos: títulos, listas, negrito, itálico, código e tabelas.
function inline(text: string, key: string): React.ReactNode[] {
  const out: React.ReactNode[] = [];
  const re = /(`[^`]+`|\*\*[^*]+\*\*|\*[^*\s][^*]*\*|\[[^\]]+\]\([^)]+\))/g;
  let last = 0;
  let m: RegExpExecArray | null;
  let i = 0;
  while ((m = re.exec(text))) {
    if (m.index > last) out.push(text.slice(last, m.index));
    const s = m[0];
    const k = key + "-" + i++;
    if (s.startsWith("`")) out.push(<code key={k} className="md-code">{s.slice(1, -1)}</code>);
    else if (s.startsWith("**")) out.push(<strong key={k}>{s.slice(2, -2)}</strong>);
    else if (s.startsWith("[")) {
      const mm = s.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
      out.push(<a key={k} href={mm?.[2]} target="_blank" rel="noreferrer" className="md-link">{mm?.[1]}</a>);
    } else out.push(<em key={k}>{s.slice(1, -1)}</em>);
    last = m.index + s.length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}

export function Markdown({ text }: { text: string }) {
  const NL = String.fromCharCode(10);
  const lines = text.replace(/\r/g, "").split(NL);
  const blocks: React.ReactNode[] = [];
  let i = 0;
  let b = 0;
  while (i < lines.length) {
    const line = lines[i];
    if (!line.trim()) { i++; continue; }
    if (line.startsWith("```")) {
      const buf: string[] = [];
      i++;
      while (i < lines.length && !lines[i].startsWith("```")) buf.push(lines[i++]);
      i++;
      blocks.push(<pre key={b++} className="md-pre">{buf.join(NL)}</pre>);
      continue;
    }
    const h = line.match(/^(#{1,4})\s+(.*)$/);
    if (h) {
      blocks.push(<div key={b++} className={"md-h md-h" + h[1].length}>{inline(h[2], "h" + b)}</div>);
      i++;
      continue;
    }
    if (/^\s*\|.*\|\s*$/.test(line) && i + 1 < lines.length && /^\s*\|[\s:|-]+\|\s*$/.test(lines[i + 1])) {
      const cells = (l: string) => l.trim().replace(/^\||\|$/g, "").split("|").map((c) => c.trim());
      const head = cells(line);
      i += 2;
      const rows: string[][] = [];
      while (i < lines.length && /^\s*\|.*\|\s*$/.test(lines[i])) rows.push(cells(lines[i++]));
      blocks.push(
        <table key={b++} className="md-table">
          <thead><tr>{head.map((c, j) => <th key={j}>{inline(c, "th" + j)}</th>)}</tr></thead>
          <tbody>{rows.map((r, ri) => <tr key={ri}>{r.map((c, j) => <td key={j}>{inline(c, "td" + ri + j)}</td>)}</tr>)}</tbody>
        </table>
      );
      continue;
    }
    if (/^\s*([-*]|\d+\.)\s+/.test(line)) {
      const ordered = /^\s*\d+\./.test(line);
      const items: string[] = [];
      while (i < lines.length && /^\s*([-*]|\d+\.)\s+/.test(lines[i])) items.push(lines[i++].replace(/^\s*([-*]|\d+\.)\s+/, ""));
      const Tag = ordered ? "ol" : "ul";
      blocks.push(<Tag key={b++} className="md-list">{items.map((it, j) => <li key={j}>{inline(it, "li" + j)}</li>)}</Tag>);
      continue;
    }
    if (/^-{3,}\s*$/.test(line)) { blocks.push(<hr key={b++} className="md-hr" />); i++; continue; }
    const para: string[] = [];
    while (i < lines.length && lines[i].trim() && !/^(#{1,4}\s|```|\s*([-*]|\d+\.)\s+|\s*\|)/.test(lines[i])) para.push(lines[i++]);
    if (!para.length) para.push(lines[i++]);
    blocks.push(<p key={b++} className="md-p">{inline(para.join(" "), "p" + b)}</p>);
  }
  return <div className="md">{blocks}</div>;
}
